import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Row, Form, FormControl, Spinner } from "react-bootstrap";
import upload_img from "../../../assets/upload_img.png";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import UploadfilesPage from "../../tusimageupload/components/UploadfilesPage";
import Commonmodal from "../../modal/components/Commonmodal";
import { useTranslation } from "react-i18next";
import { fetchHeaderContent } from "../../seoroute/redux/actions";
import information from "../../../assets/information.svg";
import close_cross from "../../../assets/close_cross.svg";
import "../../products/components/AddproductPage.css";
import { getRequestcall } from "../../comman/util/getRequest";
import {
  VAT_LIST,
  LIST_UNIT,
  ADD_MULTIPLE_PRODUCTS,
} from "../../constants/apiurl";
import { postRequestcall } from "../../comman/util/postRequest";
import VariationboxPage from "../../comman/components/VariationboxPage";
import ButtonPage from "../../comman/button/ButtonPage";
import { FormLabel } from "../../comman/formgroup/FormgroupPage";
import { clearStoredetail } from "../../dashboard/redux/actions";
import SingleselectPage from "../../comman/customselect/SingleselectPage";
import { fetchLogindata } from "../../login/redux/actions";
const HelpPage = React.lazy(() => import("../../modal/components/HelpPage"));
const DeletepopupPage = React.lazy(() =>
  import("./../../modal/components/DeletepopupPage")
);

function AddproductPage(props) {

  const navigate = useNavigate();
  const { t } = useTranslation();
  const [Click, setClick] = useState({
    next: false,
    preview: false,
  });
  const { state } = useLocation();
  const [catalogarray, setCatalogarray] = useState(state?.catalogarray);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteInfo, setDeleteinfo] = useState({
    title: t("pages.add_product.deletevariation"),
    sub_title: t("pages.add_product.variationsub_title"),
    name: "",
    id: "",
    type: "",
  });
  const errorParameter = {
    title: "",
    description: "",
    title_in_tr: "",
    description_in_tr: "",
    select_sub_category: "",
    select_category: "",
    images: "",
    sku: "",
  };
  const inputValue = {
    title: "",
    description: "",
    description_in_tr: "",
    title_in_tr: "",
    images: "",
    service_id: "",
    sub_service_id: "",
    store_id: "",
    sku: "",
    id: "",
  };
  const variantParameter = {
    quantity: "",
    price: "",
    stock: "",
    is_stock: "yes",
    discount: "",
  };
  const varianterror = {
    quantity: "",
    price: "",
    unit: "",
    stock: "",
  };
  const [showModal, setShowModal] = useState(false);
  const [errorMsg, setErrormsg] = useState(errorParameter);
  const [addProducts, setAddproducts] = useState(inputValue);
  // variant state
  const [addVariant, setAddvariant] = useState(variantParameter);
  const [variantlist, setVariantlist] = useState([]);
  // const [variantlistFirst, setVariantlistFirst] = useState([]);
  const [errorVariant, setErrorvariant] = useState(varianterror);
  // Unit list
  const [unitlist, setUnitlist] = useState([]);
  const [selectUnit, setselectUnit] = useState([]);
  const [stockhide, setStockhide] = useState(true);
  const [currentid, setCurrentid] = useState("");
  const [shownum, setShownum] = useState(0);
  const [imageName, setImagename] = useState([]);
  const [showCatalogsavemodal, setShowcatalogsavemodal] = useState(false);
  const [showAddVariation, setShowAddVariation] = useState(false);
  // vat
  const [taxarray, setTaxarray] = useState([]);
  const [selectedTax, setSelectedTax] = useState([]);
  var [showunits, setShowunits] = useState(false);
  var [showvatlist, setShowvatlist] = useState(false);

  // eslint-disable-next-line
  useEffect(() => {
    if (catalogarray) {
      setShownum(1);
      setCurrentid(catalogarray[0]?.id);
      getProductinfo(catalogarray[0]?.id);
      setDeleteinfo({
        ...deleteInfo,
        title: t("pages.add_product.deletevariation"),
        sub_title: t("pages.add_product.variationsub_title"),
        name: "",
        id: "",
        type: "",
      });
    } else {
      setCatalogarray(state?.catalogarray);
    }
    // eslint-disable-next-line
  }, [props?.language]);

  const getProductinfo = async (getid) => {
    let getProduct = catalogarray.filter((item) => item.id === getid);
    await callVatlist(getProduct);
    let tabTitle = "";
    if (props?.language === "Tr") {
      tabTitle = getProduct[0]?.title_in_tr;
    } else {
      tabTitle = getProduct[0]?.title;
    }
    props?.fetchHeaderContent(tabTitle, "", "");
    setAddproducts({
      title: getProduct[0]?.title,
      title_in_tr: getProduct[0]?.title_in_tr,
      description: getProduct[0]?.description,
      description_in_tr: getProduct[0]?.description_in_tr,
      sku: getProduct[0]?.sku ? getProduct[0]?.sku : "",
    });
    let getImagename = [];
    let imageObject = {};
    if (getProduct[0]?.imageName?.length) {
      getProduct[0]?.imageName?.forEach((item) => {
        imageObject = {
          preview_url: item.preview_url,
          fileName: item.fileName,
        };
        getImagename.push(imageObject);
      });
    } else {
      getProduct[0]?.img_url?.forEach((item) => {
        let getFilename = item.split("/").pop();
        imageObject = {
          preview_url: item,
          fileName: getFilename,
        };
        getImagename.push(imageObject);
      });
    }
    setImagename(getImagename);
    getUnitlistforvariant(
      getProduct[0]?.service_id,
      getProduct[0]?.variations,
      true
    );
    //getStoreDetail();
    setDeleteinfo({
      title: t("pages.add_product.deletevariation"),
      sub_title: t("pages.add_product.variationsub_title"),
      name: "",
      id: "",
      type: "",
    });
  };

  const callVatlist = async (getProduct) => {
    let taxlist = await getRequestcall(VAT_LIST, props?.access_token);
    let taxobj = {};
    let taxarray = [];
    if (taxlist?.status === 200) {
      let getList = await taxlist.json();
      if (getList?.data?.length !== 0) {
        getList?.data?.forEach((item) => {
          taxobj = {
            label: `${props?.language === "Tr" ? item?.vatname_in_tr : item?.vatname
              } ${item?.vatrate} ${"%"}`,
            value: item.id,
            vatrate: item?.vatrate,
          };
          taxarray.push(taxobj);
        });
        setTaxarray(taxarray);
        if (getProduct.length > 0) {
          let getVatid = taxarray?.filter(
            (item) => item?.value === getProduct[0]?.vat_id
          );
          if (getVatid.length !== 0) {
            setSelectedTax(getVatid[0]);
          } else {
            let getZerovat = taxarray?.filter((item) => item?.vatrate === "0");
            if (getZerovat?.length !== 0) {
              setSelectedTax(getZerovat[0]);
            } else {
              setSelectedTax(taxarray[0]);
            }
          }
        }
      }
    } else if (taxlist.status === 500) {
      toast.error(t("pages.internal"));
    }
  };

  const selectUnitchange = async (e, selectUnit) => {
    // console.log("selectUnit", selectUnit)
    setselectUnit(selectUnit);
    setErrorvariant({
      ...errorVariant,
      unit: "",
    });
  };

  const getUnitlistforvariant = async (value, variation, State_select) => {
    let url =
      LIST_UNIT + `?service_id=${value}&lang=${props?.language?.toLowerCase()}`;
    let getUnitlist = await getRequestcall(url, props?.access_token);
    let updatedUnitlist = [];
    if (getUnitlist?.status === 200) {
      let getList = await getUnitlist.json();
      if (getList?.data?.length > 0) {
        let unit = {};
        getList?.data?.forEach((item) => {
          unit = {
            value: item.uid,
            label: props?.language === "Tr" ? item.unit_tr : item.unit,
            label_tr: item.unit_tr,
          };
          updatedUnitlist.push(unit);
        });
        setUnitlist(updatedUnitlist);
      }
    }
    if (State_select) editSelectedvariantunitlist(updatedUnitlist, variation);
  };

  const editSelectedvariantunitlist = (updatedUnitlist, variation) => {
    let updatedVariantlist = [];
    let variant = {};
    let selectedUnit = {};
    variation.forEach((item) => {
      selectedUnit = {
        value: item.unit_id,
        label: item.unit,
        label_tr: item.unit_in_tr,
      };
      variant = {
        unit_id: item.unit_id,
        unit: item?.unit,
        unit_in_tr: item?.unit_in_tr,
        vid: item.vid,
        quantity: item.quantity,
        price: item.price,
        discount: typeof item?.discount === "undefined" ? 0 : item?.discount,
        stock: item.stock,
        is_stock: item.is_stock,
        editSelectedunit: selectedUnit,
        editUnitlist: updatedUnitlist,
        showunits: false
      };
      updatedVariantlist.push(variant);
    });
    // setVariantlistFirst(updatedVariantlist);
    setVariantlist(updatedVariantlist);
  };

  const instockvariantChange = (e) => {
    if (e.target.id === "always") {
      setStockhide(false);
      setErrorvariant({
        ...errorVariant,
        stock: "",
      });
    } else {
      setStockhide(true);
    }
    setAddvariant({
      ...addVariant,
      is_stock: e.target.id === "always" ? "no" : "yes",
    });
  };

  const addProductvaluechange = (e) => {
    setAddproducts({
      ...addProducts,
      [e.target.name]: e.target.value,
    });
    setErrormsg({
      ...errorMsg,
      title: e.target.name === "title_in_tr" ? "" : errorMsg.title,
      title_in_tr: e.target.name === "title" ? "" : errorMsg.title_in_tr,
      description:
        e.target.name === "description_in_tr" ? "" : errorMsg.description,
      description_in_tr:
        e.target.name === "description" ? "" : errorMsg.description_in_tr,
      [e.target.name]: "",
    });
  };

  const addVariantchange = (e) => {
    switch (e.target.type) {
      case "number":
        if (e.target.value > 0) {
          changeAddVariation(e);
        } else if (e.target.value === "" && e.target.value !== "-") {
          changeAddVariation(e);
        }
        break;
      case "text":
        if ((parseInt(e.target.value) > 0) || (e.target.value === "" && e.target.value !== "-")) {
          changeAddVariation(e);
        }
        break;
      default:
        break;
    }
  };
  const changeAddVariation = (e) => {
    let value = e.target.value
    if( e.target.name === "discount"){
      if(parseFloat(e.target.value) >= 0){
        console.log("addVariant.price",addVariant.price, e.target.value)
        if(parseFloat(addVariant.price) >= parseFloat(e.target.value)){
          value = e.target.value
        }else{
          value = addVariant.discount
        }
      }else{
        value = ""
      }
    }
    setAddvariant({
      ...addVariant,
      [e.target.name]: value,
    });
    setErrorvariant({
      ...errorVariant,
      [e.target.name]: "",
    });
  };

  const editVariantchange = (e, getIndex) => {
    let variant = {};
    let updatedCategorylist = [];
    variantlist.forEach((item, index) => {
      if (index === getIndex) {
        let stock_value = "";
        let stock = "";
        stock = e.target.name === "stock" ? e.target.value : item.stock;
        let discount = item?.discount
        if( e.target.name === "discount"){
          if(parseFloat(e.target.value) >= 0){
            if(parseFloat(item.price) >= parseFloat(e.target.value)){
              discount = e.target.value
            }else{
              discount = item.discount
            }
          }else{
            discount = ""
          }
        }
        if (e?.target?.id === getIndex + "variation_always") {
          stock_value = "no";
          stock = "0";
        } else if (e?.target?.id === getIndex + "variation_limited") {
          if (item.is_stock === "no") {
            stock = "0";
          }
          stock_value = "yes";
        }
        variant = {
          ...item,
          quantity:
            e.target.name === "quantity" ? e.target.value : item.quantity,
          price:
            e.target.name === "price"
              ? e.target.value > 0 || e.target.value === ""
                ? e.target.value
                : ""
              : item.price,
          discount:discount,
          stock: Number(stock) < 0 ? "0" : stock,
          is_stock: stock_value === "" ? item.is_stock : stock_value,
        };
      } else {
        variant = {
          ...item,
          discount: typeof item.discount === "undefined" ? 0 : item.discount,
        };
      }
      updatedCategorylist.push(variant);
    });
    setVariantlist(updatedCategorylist);
  };

  const editSelectunitchange = (e, selectedUnit, editIndex) => {
    e.preventDefault();
    let variant = {};
    let updatedCategorylist = [];
    variantlist.forEach((item, index) => {
      if (index === editIndex) {
        variant = {
          ...item,
          unit: selectedUnit?.label,
          unit_in_tr: selectedUnit?.label_tr,
          unit_id: selectedUnit?.value,
          discount: typeof item.discount === "undefined" ? 0 : item.discount,
          editSelectedunit: selectedUnit,
          showunits: false
        };
      } else {
        variant = {
          ...item,
          discount: typeof item.discount === "undefined" ? 0 : item.discount,
        };
      }
      updatedCategorylist.push(variant);
    });
    setVariantlist(updatedCategorylist);
  };

  const validationVariant = () => {
    let check_value = true;

    if (addVariant.quantity === "") {
      check_value = false;
      errorVariant.quantity = "pages.add_product.qty_warn";
    }

    if (addVariant.price === "") {
      check_value = false;
      errorVariant.price = "pages.add_product.price_warn";
    }

    if (selectUnit.length === 0) {
      check_value = false;
      errorVariant.unit = "pages.add_product.unites_place";
    }

    if (stockhide === true) {
      if (addVariant.stock <= 0) {
        check_value = false;
        errorVariant.stock = "pages.add_product.enterstock";
      }
    }
    setErrorvariant({
      quantity: errorVariant.quantity,
      price: errorVariant.price,
      unit: errorVariant.unit,
      stock: errorVariant.stock,
    });

    if (check_value === false) {
      return false;
    } else {
      return true;
    }
  };

  const validation = () => {
    let checkValue = true;
    if (addProducts?.title === "" && addProducts?.title_in_tr === "") {
      if (props?.language === "Tr") {
        errorMsg.title_in_tr = "pages.add_product.pname_warn";
      } else {
        errorMsg.title = "pages.add_product.pname_warn";
      }
      checkValue = false;
    }
    if (
      addProducts?.description === "" &&
      addProducts?.description_in_tr === ""
    ) {
      if (props?.language === "Tr") {
        errorMsg.description_in_tr = "pages.add_product.description_warn";
        if (addProducts?.description_in_tr?.length < 10) {
          errorMsg.description_in_tr = "pages.add_product.description_valid";
          checkValue = false;
        }
      } else {
        errorMsg.description = "pages.add_product.description_warn";
        if (addProducts?.description?.length < 10) {
          errorMsg.description = "pages.add_product.description_valid";
          checkValue = false;
        }
      }
      checkValue = false;
    }
    if (variantlist.length === 0) {
      if (validationVariant() === false) {
        checkValue = false;
      }
    }
    if (variantlist.length === 0) {
      toast.error(t("pages.add_product.variation_toast"));
      checkValue = false;
    }
    if (imageName.length === 0) {
      errorMsg.images = "pages.add_product.file_warn";
      checkValue = false;
    }
    console.log("errorMsg", errorMsg  )
    setErrormsg({
      title: errorMsg.title,
      description: errorMsg.description,
      title_in_tr: errorMsg.title_in_tr,
      description_in_tr: errorMsg.description_in_tr,
      select_category: errorMsg.select_category,
      select_sub_category: errorMsg.select_sub_category,
      images: errorMsg.images,
    });
    if (checkValue === false) {
      return false;
    } else {
      return true;
    }
  };

  const onEditStateChange = () => {
    // eslint-disable-next-line array-callback-return
    const responceVariation = variantlist?.map((item, index) => {
      return onCheckEditStateChange(index);
    });
    const result = responceVariation?.filter((item) => item === false);
    if (result?.length === 0) {
      return true;
    } else {
      toast.info(t("pages.add_product.invaild_varition"));
      return false;
    }
  };
  const onCheckEditStateChange = (index) => {
    const variation = variantlist[index];
    let value = true;
    if (variation?.price === "") {
      value = false;
    }
    if (variation?.quantity === "") {
      value = false;
    }
    if (variation?.is_stock !== "no") {
      if (variation?.stock <= 0) {
        value = false;
      }
    }
    if (value === true) {
      //setVariationEditState("");
      return value;
    } else {
      return false;
    }
    //setVariationEditState("");
  };
  // Add variant to list
  const addVarianttoList = (e) => {
    e.preventDefault();
    if (validationVariant()) {
      let updatedVariantlist = [...variantlist];
      let variant = {
        vid: "",
        unit: selectUnit?.label,
        unit_in_tr: selectUnit?.label_tr,
        unit_id: selectUnit?.value,
        quantity: addVariant.quantity,
        discount:
          typeof addVariant.discount === "undefined" ? 0 : addVariant.discount,
        price: addVariant.price,
        stock:
          addVariant.stock === "" || Number(addVariant.stock) < 0
            ? "0"
            : addVariant.stock,
        is_stock: addVariant.is_stock,
        editSelectedunit: selectUnit,
        editUnitlist: unitlist,
        showunits: false
      };
      updatedVariantlist.push(variant);
      setVariantlist(updatedVariantlist);
      // setVariantlistFirst(updatedVariantlist);
      setselectUnit({ label: "", value: "" });
      setAddvariant({
        quantity: "",
        price: "",
        stock: "",
        is_stock: "yes",
        discount: ""
      });
      setStockhide(true);
      setShowAddVariation(false);
    }
  };

  const deleteCurrentprodut = (e) => {
    e.preventDefault();
    if (shownum === 1) {
      let getProductlist = catalogarray.filter((item) => item.id !== currentid);
      if (getProductlist.length === 0) {
        navigate("../");
      } else {
        setCatalogarray(getProductlist);
        setCurrentid(getProductlist[0]?.id);
        getProductinfo(getProductlist[0]?.id);
      }
    } else {
      let getProductlist = catalogarray.filter((item) => item.id !== currentid);
      setCatalogarray(getProductlist);
      setCurrentid(getProductlist[shownum - 2]?.id);
      getProductinfo(getProductlist[shownum - 2]?.id);
      setShownum(shownum - 1);
    }
  };
  const getUpdatedList = () => {
    let getZerovat = taxarray?.filter((item) => item?.vatrate === "0");
    let getProduct = {};
    let productList = [];
    catalogarray.forEach((item) => {
      if (item.id === currentid) {
        let updatedimage = [];
        imageName.forEach((item) => {
          updatedimage.push(item.fileName);
        });
        getProduct = {
          ...item,
          description: addProducts.description,
          description_in_tr: addProducts.description_in_tr,
          img_url: updatedimage,
          imageName: imageName,
          title: addProducts.title,
          title_in_tr: addProducts.title_in_tr,
          variations: variantlist,
          sku: addProducts?.sku,
          vat_id: selectedTax.value,
        };
      } else {
        getProduct = {
          ...item,
          vat_id:
            item?.vat_id !== undefined
              ? item?.vat_id
              : getZerovat?.length !== 0
                ? getZerovat[0]?.value
                : taxarray[0]?.value,
        };
      }
      productList.push(getProduct);
    });
    setCatalogarray(productList);
    return productList;
  };

  const backProduct = async (e) => {
    e.preventDefault();
    if (validation() && onEditStateChange()) {
      if (shownum !== 1) {
        setClick({ ...Click, preview: true });
        getUpdatedList();
        await setCurrentid(catalogarray[shownum - 2]?.id);
        await getProductinfo(catalogarray[shownum - 2]?.id);
        setShownum(shownum - 1);
        setTimeout(() => setClick({ ...Click, preview: false }), 1000);
      }
    }
  };
  const nextProduct = async (e) => {
    e.preventDefault();
    if (validation() && onEditStateChange()) {
      if (catalogarray.length !== shownum) {
        setClick({ ...Click, next: true });
        getUpdatedList();
        await setCurrentid(catalogarray[shownum]?.id);
        await getProductinfo(catalogarray[shownum]?.id);
        setShownum(shownum + 1);
        setTimeout(() => setClick({ ...Click, next: false }), 1000);
      }
    }
  };

  const closeCurrentimage = (id) => {
    const updateImagenameArray = imageName.filter(
      (item, index) => index !== id
    );
    setImagename(updateImagenameArray);
  };
  const ShowSavemodal = (e) => {
    e.preventDefault();
    if (showAddVariation) {
      if (validation() && validationVariant() && onEditStateChange()) {
        setShowcatalogsavemodal(true);
      }
    } else {
      if (onEditStateChange()) {
        if (validation()) {
          setShowcatalogsavemodal(true);
        }
      }
    }
  };
  const skipallProducts = async () => {
    let getProductlist = getUpdatedList();
    let updatedProduct = {};
    let updatedVariation = {};
    let updatedProductList = [];
    getProductlist.forEach((item) => {
      let updatedVariationlist = [];
      item.variations.forEach((item) => {
        updatedVariation = {
          is_stock: item?.is_stock,
          price: item?.price,
          discount: typeof item?.discount === "undefined" ? 0 : item?.discount,
          quantity: item?.quantity,
          stock: item?.stock,
          unit_id: item?.unit_id,
        };
        updatedVariationlist.push(updatedVariation);
      });
      let getImages = item?.img_url
        .map((getImage) => {
          let value = getImage?.includes("master_product");
          if (value === true) {
            return (getImage = "/" + getImage?.split("/").pop());
          } else {
            if (getImage === item.images) {
              return (getImage = "/" + item.images);
            } else {
              return getImage;
            }
          }
        })
        .join(",");
      const EDescription =
        item?.description === "" ? item?.description_in_tr : item?.description;
      const TDescription =
        item?.description_in_tr === ""
          ? item?.description
          : item?.description_in_tr;
      const ETitle = item?.title === "" ? item?.title_in_tr : item?.title;
      const TTitle = item?.title_in_tr === "" ? item?.title : item?.title_in_tr;
      updatedProduct = {
        description: EDescription,
        description_in_tr: TDescription,
        images: getImages,
        service_id: item.service_id,
        sub_service_id: item.sub_service_id,
        store_id: props?.store_id,
        title_in_tr: TTitle,
        title: ETitle,
        variation: updatedVariationlist,
        sku: item?.sku,
        vat_id: item?.vat_id,
      };
      updatedProductList.push(updatedProduct);
    });
    let getProducts = {};
    getProducts = {
      data: updatedProductList,
    };
    let getaddMultipleProductsapiresponse = await postRequestcall(
      ADD_MULTIPLE_PRODUCTS,
      props?.access_token,
      getProducts
    );
    if (getaddMultipleProductsapiresponse?.status === 200) {
      toast.success(t("pages.your product adding request is waitng for admin approve!"));
      window.history.replaceState({}, document.title);
      navigate("../../");
    } else if (getaddMultipleProductsapiresponse?.status === 400) {
      let getError = await getaddMultipleProductsapiresponse.json();
      if(getError?.error?.is_deleted) {
        props?.clearStoredetail([]);
        props.logindata.type = "user";
        props.fetchLogindata(props.logindata);
        toast.error(getError?.errors);
        navigate("/vendor/");
      }else{
        toast.error(getError?.errors);
      }
    }
  };

  const onSelectVat = async (e, selectedVat, index) => {
    e.preventDefault();
    setSelectedTax(selectedVat);
    setShowvatlist(false);
  };
  // {t('pages.delete')} variant from list
  const deleteVariantfromlist = (getindex) => {
    const updateVariantlist = variantlist.filter(
      (item, index) => index !== getindex
    );
    setVariantlist(updateVariantlist);
    //setVariantlistFirst(updateVariantlist);
  };
  const itemDelete = async () => {
    deleteVariantfromlist(deleteInfo?.id);
    setDeleteModal(false);
  };
  const productDelete = (e, item) => {
    e.preventDefault();
    setDeleteinfo({
      ...deleteInfo,
      name: item.title,
      id: item,
    });
    setDeleteModal(true);
  };

  const storeFiles = (getImage, type) => {
    let imagevalue = [...imageName];
    imagevalue.push(getImage);
    setImagename(imagevalue);
  };

  const unitListopen = (e, getIndex) => {
    e.preventDefault();
    if (variantlist[getIndex].showunits) {
      let array = [...variantlist]
      array[getIndex].showunits = false;
      setVariantlist(array);
    } else {
      let array = [...variantlist]
      array[getIndex].showunits = true;
      setVariantlist(array);
    }
  }

  const unitListclose = () => {
    let array = [...variantlist];
    array = array.map((item)=>{ return { ...item, showunits:false } });
    setVariantlist(array);
  }

  const selectedTaxrender = (item) => {
    const getTax = taxarray.filter(
      (tax) => tax?.value === item.value
    );
    if (getTax?.length > 0) {
      return getTax[0]?.label;
    };
  }

  return (
    <div className="col-xl-9 main-content add-product">
      <div className="card">
        <div className="card-body">
          <h5 className="header-title mb-3">{t("pages.add_product.title")}</h5>
          <Form>
            <Row>
              <div className="col-sm-12 col-md-12 col-lg-6 col-xl-6 pb-4">
                <Form.Group>
                  <Form.Label>
                    {t("pages.add_product.pname")} {t("pages.In English")}
                  </Form.Label>
                  <Form.Control
                    placeholder={t("pages.add_product.pname_place")}
                    value={addProducts?.title}
                    name={"title"}
                    onChange={addProductvaluechange}
                  />
                  <div className="text-danger">{t(errorMsg.title)}</div>
                </Form.Group>
              </div>
              <div className="col-sm-12 col-md-12 col-lg-6 col-xl-6 pb-4">
                <Form.Group>
                  <Form.Label>
                    {t("pages.add_product.pname")} {t("pages.In Turkish")}
                  </Form.Label>
                  <Form.Control
                    placeholder={t("pages.add_product.pname_place")}
                    value={addProducts?.title_in_tr}
                    name={"title_in_tr"}
                    onChange={addProductvaluechange}
                  />
                  <div className="text-danger">{t(errorMsg.title_in_tr)}</div>
                </Form.Group>
              </div>
              <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <div className="stock-selection">
                  <h5 className="">{t("pages.add_product.variation")}</h5>
                  <div onClick={() => setShowModal(true)} className="help-info">
                    <img
                      src={information}
                      title={t("pages.Help")}
                      alt={"help"}
                      height="25"
                      width="25"
                    ></img>
                    <span>{t("pages.Help")}</span>
                  </div>
                </div>
              </div>
              <div>
                {variantlist?.map((item, index) => (
                  <VariationboxPage
                    addVariantchange={(e) => editVariantchange(e, index)}
                    addVariant={item}
                    setShowAddVariation={setShowAddVariation}
                    unitlist={item.editUnitlist}
                    selectUnit={item.editSelectedunit}
                    selectUnitchange={editSelectunitchange}
                    stockhide={item.is_stock}
                    list={true}
                    productDelete={(e) => productDelete(e, index)}
                    instockvariantChange={(e) => editVariantchange(e, index)}
                    index={index}
                    type={"unit_list"}
                    unitListopen={unitListopen}
                    unitListclose={unitListclose}
                    showunits={item?.showunits}
                  />
                ))}
              </div>
              {showAddVariation === false && (
                <div className="mb-3 text-end">
                  <button
                    onClick={() => setShowAddVariation(true)}
                    className="btn-submit  py-1"
                  >
                    {t("pages.add_product.add_variant")}
                  </button>
                </div>
              )}
              {showAddVariation === true && (
                <div className="new variant">
                  <VariationboxPage
                    addVariantchange={(e) => addVariantchange(e)}
                    addVariant={addVariant}
                    setShowAddVariation={setShowAddVariation}
                    unitlist={unitlist}
                    selectUnit={selectUnit}
                    addVarianttoList={addVarianttoList}
                    selectUnitchange={selectUnitchange}
                    stockhide={stockhide}
                    errorVariant={errorVariant}
                    instockvariantChange={instockvariantChange}
                    list={false}
                    setShowcategorylist={setShowunits}
                    showCategorylist={showunits}
                  />
                </div>
              )}
              <div className="col-sm-12 col-md-12 col-lg-6 col-xl-6 pb-4">
                <Form.Group>
                  <Form.Label>{t("pages.add_product.sku")}</Form.Label>
                  <FormControl
                    placeholder={t("pages.add_product.sku_place")}
                    value={addProducts?.sku}
                    name={"sku"}
                    onChange={addProductvaluechange}
                  />
                </Form.Group>
              </div>
              <div className="col-sm-12 col-md-12 col-lg-6 col-xl-6 pb-4 position-relative">
                <Form.Group>
                  <Form.Label>{t("pages.add_product.tax")}</Form.Label>
                  <SingleselectPage
                    groupItemClick={onSelectVat}
                    list={taxarray}
                    setShowList={setShowvatlist}
                    showList={showvatlist}
                    placeholder={""}
                    value={selectedTaxrender(selectedTax)}
                  />
                </Form.Group>
              </div>
              <div hidden className="col-sm-12 col-md-12 col-lg-6 col-xl-6 " />
              <div className="col-sm-12 col-md-12 col-lg-6 col-xl-6 pb-4">
                <Form.Group>
                  <Form.Label>
                    {t("pages.add_product.description")} {t("pages.In English")}
                  </Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={7}
                    placeholder={t("pages.add_product.description_place")}
                    style={{ height: "auto" }}
                    className="description"
                    value={addProducts?.description}
                    name={"description"}
                    onChange={addProductvaluechange}
                  />
                  <div className="text-danger">{t(errorMsg.description)}</div>
                </Form.Group>
              </div>
              <div className="col-sm-12 col-md-12 col-lg-6 col-xl-6 pb-4">
                <Form.Group>
                  <Form.Label>
                    {t("pages.add_product.description")} {t("pages.In Turkish")}
                  </Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={7}
                    placeholder={t("pages.add_product.description_place")}
                    style={{ height: "auto" }}
                    className="description"
                    value={addProducts?.description_in_tr}
                    name={"description_in_tr"}
                    onChange={addProductvaluechange}
                  />
                  <div className="text-danger">
                    {t(errorMsg.description_in_tr)}
                  </div>
                </Form.Group>
              </div>
              <div className=" col-sm-12 col-md-12 col-lg-6 col-xl-6 mb-4 pb-2 upload-profiles">
                <FormLabel label={t("pages.setupstore.other_document")} />
                <div className="productimage_div">
                  <div class="multi-upload-img">
                    <UploadfilesPage storeFiles={storeFiles} />
                    <div
                      className="text-danger"
                      style={{ whiteSpace: "nowrap" }}
                    >
                      {imageName.length === 0 ? t(errorMsg.images) : ""}
                    </div>
                  </div>

                  <div className={"sidebar-cateloge-slider"}>
                    <div className={"sidebar-carasoul-slider"}>
                      {imageName?.map((item, index) => (
                        <div
                          class="multi-upload-img"
                          style={{ marginBottom: "20px" }}
                        >
                          <img
                            src={close_cross}
                            className="close-icon"
                            onClick={() => closeCurrentimage(index)}
                            alt="close"
                          />
                          <img
                            src={item?.preview_url}
                            onError={(e) => {
                              e.target.src = upload_img;
                            }}
                            class="product-img"
                            alt="product"
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
              <div className="catalog-footer pb-md-0 col-sm-12 col-md-12 col-lg-12 col-xl-12 pb-4">
                <div className="paginations_div desktop d-flex align-items-center">
                  <button
                    className="btn-white px-4"
                    onClick={(e) => deleteCurrentprodut(e)}
                  >
                    {t("pages.delete")}
                  </button>
                  <>
                    {Click?.preview ? (
                      <ButtonPage
                        type="button"
                        className="button-secondry add-product preview-btn btn-submit"
                        style={{ background: "#ffe1d9", color: "#fe2e00" }}
                        Text={
                          <div className="d-flex align-items-center justify-content-center gap-2">
                            <Spinner
                              animation="border"
                              variation={"primary"}
                              size="sm"
                              className={"me-2"}
                            />{" "}
                            {t("pages.preview")}
                          </div>
                        }
                        onClick={() => { }}
                      />
                    ) : (
                      <ButtonPage
                        className="button-secondry add-product preview-btn btn-submit"
                        onClick={backProduct}
                        Text={t("pages.preview")}
                        type="button"
                      />
                    )}
                  </>
                  <label className="number-start">{shownum}</label>
                  <h5 className="number-of" style={{ fontSize: "16px" }}>
                    {t("pages.of")}
                  </h5>
                  <label className="number-end">{catalogarray?.length}</label>
                  {Click?.next ? (
                    <ButtonPage
                      type="button"
                      className="button-black btn-black"
                      Text={
                        <div className="d-flex align-items-center justify-content-center gap-2">
                          <Spinner
                            animation="border"
                            variation={"primary"}
                            size="sm"
                          />{" "}
                          {t("pages.next")}
                        </div>
                      }
                      onClick={() => { }}
                    />
                  ) : (
                    <ButtonPage
                      className="button-black btn-black px-5"
                      onClick={!Click?.next && nextProduct}
                      Text={t("pages.next")}
                      type="button"
                    />
                  )}
                  <ButtonPage
                    className="add-product button-submit px-5 "
                    onClick={(e) => ShowSavemodal(e)}
                    Text={t("pages.done")}
                  />
                </div>
              </div>
            </Row>
          </Form>
        </div>
      </div>
      {showModal && (
        <HelpPage setShowModal={setShowModal} showModal={showModal} />
      )}
      <Commonmodal
        skipallProducts={skipallProducts}
        showCatalogsavemodal={showCatalogsavemodal}
        setShowcatalogsavemodal={setShowcatalogsavemodal}
      />
      {deleteModal && (
        <DeletepopupPage
          setDeleteModal={setDeleteModal}
          deleteInfo={deleteInfo}
          deleteModal={deleteModal}
          itemDelete={itemDelete}
        ></DeletepopupPage>
      )}
    </div>
  );
}

const mapStateToProps = (state) => ({
  storeDetail: state?.dashboard?.storeDetail,
  access_token: state?.login.access_token,
  categories: state?.home.categories,
  store_id: state?.dashboard?.storeDetail?.store_id,
  language: state?.languageState?.language,
  ipaddress: state?.login?.ipaddress,
  logindata: state?.login?.logindata
});

export default connect(mapStateToProps, { fetchHeaderContent, clearStoredetail,fetchLogindata })(AddproductPage);
